import { render, staticRenderFns } from "./VBurger.vue?vue&type=template&id=54f5340b&"
import script from "./VBurger.vue?vue&type=script&lang=js&"
export * from "./VBurger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports